<template>
  <div>
    <div class="row">
      <div class="col-md-6 pl-24">
        <mail></mail>
        <internal-task-activities></internal-task-activities>
      </div>
      <div class="col-md-6 pr-24">
        <task-template-manager></task-template-manager>
        <tags></tags>
        <services></services>
      </div>
    </div>
  </div>
</template>
<script>
import Mail from './mail'
import Tags from './tags'
import TaskTemplateManager from './task-template-manager'
import InternalTaskActivities from './internal-task-activities.vue'
import Services from './services'

export default {
  components: {
    Mail,
    Tags,
    TaskTemplateManager,
    InternalTaskActivities,
    Services,
  },
}
</script>



// WEBPACK FOOTER //
// src/views/config/Index.vue